import styled from 'styled-components';

const Box = styled.div`
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-color: #fff;
  background: url(${props => props.backgroundImage}) right no-repeat;
  background-position: right;
  display: flex;
  align-items: center;
  height: 100%;
  position: absolute;
  width: 100%;
  padding: 100px;

  @media (max-width: 768px) {
    padding: 15px;
    justify-content: center;
    align-items: flex-end;
  }
`

Box.Container = styled.div`
  max-width: 400px;
`

Box.Content = styled.div`
  border-radius: 20px;
  padding: 30px;
  background: linear-gradient(118deg, #c4d8e8, #a7b1c1);
  box-shadow: 0 4px 6px 0 rgba(85, 85, 85, 0.09019607843137255), 
            0 1px 20px 0 rgba(0, 0, 0, 0.08), 
            0px 1px 11px 0px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    padding: 15px;
  }
`

Box.Logo = styled.img`
  max-width: 200px;
`

export default Box